export function countWords(str: string): number {
  if (!str || typeof str !== 'string') return 0;
  
  // Remove HTML tags and entities
  const text = str.replace(/<[^>]*>/g, ' ').replace(/&[^;]+;/g, ' ');
  
  // Split by whitespace and filter out empty strings
  const words = text.trim().split(/\s+/).filter(word => word.length > 0);
  
  return words.length;
}

export function minutesToReadableTime(minutes: number): string {
  if (minutes < 60) {
    return `${Math.floor(minutes)} min${minutes !== 1 ? 's' : ''}`;
  }
  
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes % 60);
  
  if (remainingMinutes === 0) {
    return `${hours} hr${hours !== 1 ? 's' : ''}`;
  }
  
  return `${hours} hr${hours !== 1 ? 's' : ''} ${remainingMinutes} min${remainingMinutes !== 1 ? 's' : ''}`;
}

export function formatDateForEdit(dateString: string | undefined): string {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

export function isMarkdownHeading(line: string): boolean {
  return /^#{1,6}\s+/.test(line);
}

export function getHeadingLevel(line: string): number | null {
  const match = line.match(/^(#{1,6})\s+/);
  return match ? match[1].length : null;
}

export function extractHeadingsFromMarkdown(markdown: string): { text: string; level: number }[] {
  const lines = markdown.split('\n');
  const headings: { text: string; level: number }[] = [];
  
  for (const line of lines) {
    const level = getHeadingLevel(line);
    
    if (level) {
      const text = line.replace(/^#{1,6}\s+/, '').trim();
      headings.push({ text, level });
    }
  }
  
  return headings;
}

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
